export default __webpack_public_path__ + "4eea28cbe356ba3f241a76df3c2c1797.jpg";